import {
  COMMON_PROPERTY_NAMES,
  FIELD_PROPERTY_NAMES,
  FORM_PROPERTY_NAMES,
  GROUP_PROPERTY_NAMES,
  VALIDATION_PROPERTY_NAMES,
} from '../../../store/modules/form-designer/constants/property-names'
import {
  COMMON_PROPERTY_SCHEMA_NAMES,
  DYNAMIC_PROPERTY_SCHEMA_NAMES,
  FIELD_PROPERTY_SCHEMA_NAMES,
  FORM_PROPERTY_SCHEMA_NAMES,
} from '../../../store/modules/form-designer/constants/schema-names'
import { DESIGNER_TOOLS, FIELD_TYPES } from '../../../consts'
import { VIEWS } from '../../../store/modules/form-designer/constants/constants'
import { LABELS } from './labels'

export const FormDesignerOptions = {
  formTableFilters: {
    type: 'array',
    format: 'table',
    title: LABELS.FD_AVAILABLE_TABLES_WHERE_CLAUSES,
    uniqueItems: true,
    options: {
      collapsed: false,
    },
    items: {
      type: 'object',
      title: LABELS.FD_TABLES_ADD_WHERE_CLAUSE,
      properties: {
        key: { title: LABELS.FD_WHERE_KEY, type: 'string' },
        value: { title: LABELS.FD_WHERE_VALUE, type: 'string' },
      },
    },
  },
  toolbarOptions: {
    type: 'object',
    title: LABELS.FD_TOOLBAR_OPTIONS,
    format: 'grid-strict',
    options: {
      collapsed: true,
    },
    properties: {
      formSave: {
        title: LABELS.FD_FORM_SAVE,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 4 },
        default: true,
      },
      formProperties: {
        title: VIEWS.form.title,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 4 },
        default: true,
      },
      palette: {
        title: VIEWS[DESIGNER_TOOLS.PALETTE].title,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 4 },
        default: true,
      },
      gui: {
        title: VIEWS[DESIGNER_TOOLS.GUI_SETTINGS].title,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 4 },
        default: true,
      },
      verifications: {
        title: VIEWS[DESIGNER_TOOLS.VERIFICATIONS].title,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 4 },
        default: true,
      },
      fieldImport: {
        title: VIEWS[DESIGNER_TOOLS.FIELD_IMPORTER].title,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 4 },
        default: true,
      },
      managerMode: {
        title: VIEWS[DESIGNER_TOOLS.MANAGER_MODE].title,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 4 },
        default: true,
      },
      generateWithAi: {
        title: VIEWS[DESIGNER_TOOLS.GENERATE_FIELDS].title,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 4 },
        default: true,
      },
      search: {
        title: VIEWS[DESIGNER_TOOLS.DESIGNER_FINDER].title,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 4 },
        default: true,
      },
    },
  },
  verification: {
    type: 'object',
    title: LABELS.FD_VERIFICATION_AVAILABLE_FEATURES,
    format: 'grid-strict',
    options: {
      collapsed: true,
    },
    properties: {
      [VALIDATION_PROPERTY_NAMES.ADD_NEW_VALIDATION]: {
        title: LABELS.FD_ADD_NEW_VALIDATION,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 6 },
        default: true,
      },
      [VALIDATION_PROPERTY_NAMES.ADD_NEW_LIGHT_VALIDATION]: {
        title: LABELS.FD_ADD_NEW_LIGHT_VALIDATION,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 6 },
        default: true,
      },
    },
  },
  formOptions: {
    type: 'object',
    title: LABELS.FD_FORM_AVAILABLE_FEATURES,
    format: 'grid-strict',
    options: {
      collapsed: true,
    },
    properties: {
      show: {
        title: LABELS.FD_ENABLE_FORM_PROPERTIES,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 12 },
        default: true,
      },
      [FORM_PROPERTY_NAMES.SYSTEM]: {
        title: LABELS[FORM_PROPERTY_SCHEMA_NAMES.SYSTEM],
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 4 },
        default: true,
      },
      [COMMON_PROPERTY_NAMES.NAME]: {
        title: LABELS[COMMON_PROPERTY_SCHEMA_NAMES.NAME],
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 4 },
        default: true,
      },
      [COMMON_PROPERTY_NAMES.DESCRIPTION]: {
        title: LABELS[COMMON_PROPERTY_SCHEMA_NAMES.DESCRIPTION],
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 4 },
        default: true,
      },
      [FORM_PROPERTY_NAMES.URL]: {
        title: LABELS[FORM_PROPERTY_SCHEMA_NAMES.URL],
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 4 },
        default: true,
      },
      [FORM_PROPERTY_NAMES.TAGS]: {
        title: LABELS[FORM_PROPERTY_SCHEMA_NAMES.TAGS],
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 4 },
        default: true,
      },
      [FORM_PROPERTY_SCHEMA_NAMES.DISPLAY_NAME]: {
        title: LABELS[FORM_PROPERTY_SCHEMA_NAMES.DISPLAY_NAME],
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 4 },
        default: true,
      },
      [FORM_PROPERTY_SCHEMA_NAMES.LOCALIZATION_KEY]: {
        title: LABELS[FORM_PROPERTY_SCHEMA_NAMES.LOCALIZATION_KEY],
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 4 },
        default: true,
      },
      [FORM_PROPERTY_SCHEMA_NAMES.MENU_ASSIGNER]: {
        title: LABELS[FORM_PROPERTY_SCHEMA_NAMES.MENU_ASSIGNER],
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 4 },
        default: true,
      },
      activeProperties: {
        type: 'object',
        title: LABELS.FD_FORM_ACTIVE_PROPERTIES,
        format: 'grid-strict',
        options: {
          collapsed: false,
          grid_columns: 12,
        },
        properties: {
          show: {
            title: LABELS.FD_ENABLE_FORM_ACTIVE_PROPERTIES,
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 12 },
            default: true,
          },
          [DYNAMIC_PROPERTY_SCHEMA_NAMES.READ_ONLY_EXP]: {
            title: LABELS[DYNAMIC_PROPERTY_SCHEMA_NAMES.READ_ONLY_EXP],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [DYNAMIC_PROPERTY_SCHEMA_NAMES.SAVE_EXP]: {
            title: LABELS[DYNAMIC_PROPERTY_SCHEMA_NAMES.SAVE_EXP],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
        },
      },
    },
  },
  pageOptions: {
    type: 'object',
    title: LABELS.FD_PAGE_AVAILABLE_FEATURES,
    format: 'grid',
    options: {
      collapsed: true,
    },
    properties: {
      show: {
        title: LABELS.FD_PAGE_AVAILABLE_FEATURES,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 4 },
        default: true,
      },
      addOrRemovePages: {
        title: LABELS.FD_PAGE_ADD_AND_REMOVE,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 8 },
        default: true,
      },
      [COMMON_PROPERTY_NAMES.LOCALIZATION_KEY]: {
        title: LABELS[COMMON_PROPERTY_SCHEMA_NAMES.LOCALIZATION_KEY],
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 4 },
        default: true,
      },
      [COMMON_PROPERTY_NAMES.DISPLAY_NAME]: {
        title: LABELS[COMMON_PROPERTY_SCHEMA_NAMES.DISPLAY_NAME],
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 4 },
        default: true,
      },
      [COMMON_PROPERTY_NAMES.DESCRIPTION]: {
        title: LABELS[COMMON_PROPERTY_SCHEMA_NAMES.DESCRIPTION],
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 4 },
        default: true,
      },
      activeProperties: {
        type: 'object',
        title: LABELS.FD_PAGE_ACTIVE_PROPERTIES,
        format: 'grid-strict',
        options: {
          collapsed: false,
          grid_columns: 12,
        },
        properties: {
          show: {
            title: LABELS.FD_ENABLE_PAGE_ACTIVE_PROPERTIES,
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 12 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.LABEL_EXP]: {
            title: LABELS[DYNAMIC_PROPERTY_SCHEMA_NAMES.LABEL_EXP],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.HIDDEN_EXP]: {
            title: LABELS[DYNAMIC_PROPERTY_SCHEMA_NAMES.HIDDEN_EXP],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.READ_ONLY_EXP]: {
            title: LABELS[DYNAMIC_PROPERTY_SCHEMA_NAMES.READ_ONLY_EXP],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
        },
      },
    },
  },
  groupOptions: {
    type: 'object',
    title: LABELS.FD_GROUP_AVAILABLE_FEATURES,
    format: 'grid',
    options: {
      collapsed: true,
    },
    properties: {
      show: {
        title: LABELS.FD_GROUP_AVAILABLE_FEATURES,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 4 },
        default: true,
      },
      addOrRemoveGroups: {
        title: LABELS.FD_GROUP_ADD_AND_REMOVE,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 8 },
        default: true,
      },
      [COMMON_PROPERTY_NAMES.LOCALIZATION_KEY]: {
        title: LABELS[COMMON_PROPERTY_SCHEMA_NAMES.LOCALIZATION_KEY],
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 4 },
        default: true,
      },
      [COMMON_PROPERTY_NAMES.DISPLAY_NAME]: {
        title: LABELS[COMMON_PROPERTY_SCHEMA_NAMES.DISPLAY_NAME],
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 4 },
        default: true,
      },
      [COMMON_PROPERTY_NAMES.DESCRIPTION]: {
        title: LABELS[COMMON_PROPERTY_SCHEMA_NAMES.DESCRIPTION],
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 4 },
        default: true,
      },
      [GROUP_PROPERTY_NAMES.INVISIBLE_BORDER]: {
        title: LABELS[GROUP_PROPERTY_NAMES.INVISIBLE_BORDER],
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 4 },
        default: true,
      },
      activeProperties: {
        type: 'object',
        title: LABELS.FD_GROUP_ACTIVE_PROPERTIES,
        format: 'grid-strict',
        options: {
          collapsed: false,
          grid_columns: 12,
        },
        properties: {
          show: {
            title: LABELS.FD_ENABLE_GROUP_ACTIVE_PROPERTIES,
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 12 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.LABEL_EXP]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.LABEL_EXP],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.HIDDEN_EXP]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.HIDDEN_EXP],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.READ_ONLY_EXP]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.READ_ONLY_EXP],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
        },
      },
    },
  },
  palette: {
    type: 'object',
    title: LABELS.FD_PALETTE_AVAILABLE_ITEMS,
    format: 'grid-strict',
    options: {
      collapsed: true,
    },
    properties: {
      [FIELD_TYPES.TEXT]: {
        title: LABELS.FIELD_TYPE_TEXT,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 3 },
        default: true,
      },
      [FIELD_TYPES.EMAIL]: {
        title: LABELS.FIELD_TYPE_EMAIL,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 3 },
        default: true,
      },
      [FIELD_TYPES.NUMBER]: {
        title: LABELS.FIELD_TYPE_NUMBER,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 3 },
        default: true,
      },
      [FIELD_TYPES.PASSWORD]: {
        title: LABELS.FIELD_TYPE_PASSWORD,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 3 },
        default: true,
      },
      [FIELD_TYPES.LABEL]: {
        title: LABELS.FIELD_TYPE_LABEL,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 3 },
        default: true,
      },
      [FIELD_TYPES.RICH_TEXT]: {
        title: LABELS.FIELD_TYPE_RICH_TEXT,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 3 },
        default: true,
      },
      [FIELD_TYPES.EXPRESSION_EDITOR]: {
        title: LABELS.FIELD_TYPE_EXPRESSION_EDITOR,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 3 },
        default: true,
      },
      [FIELD_TYPES.COMMENT]: {
        title: LABELS.FIELD_TYPE_COMMENT,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 3 },
        default: true,
      },
      [FIELD_TYPES.DATETIME]: {
        title: LABELS.FIELD_TYPE_DATETIME_LOCAL,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 3 },
        default: true,
      },
      [FIELD_TYPES.DATE]: {
        title: LABELS.FIELD_TYPE_DATE,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 3 },
        default: true,
      },
      [FIELD_TYPES.TIME]: {
        title: LABELS.FIELD_TYPE_TIME,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 3 },
        default: true,
      },
      [FIELD_TYPES.CHECKBOX]: {
        title: LABELS.FIELD_TYPE_CHECKBOX,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 3 },
        default: true,
      },
      [FIELD_TYPES.CHECKBOX_LIST]: {
        title: LABELS.FIELD_TYPE_CHECKBOX_LIST,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 3 },
        default: true,
      },
      [FIELD_TYPES.RADIO_BUTTON_LIST]: {
        title: LABELS.FIELD_TYPE_RADIOBUTTON_LIST,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 3 },
        default: true,
      },
      [FIELD_TYPES.SQL_CHOSEN]: {
        title: LABELS.FIELD_TYPE_SQL_CHOSEN,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 3 },
        default: true,
      },
      [FIELD_TYPES.DROPDOWN]: {
        title: LABELS.FIELD_TYPE_DROPDOWN_LIST,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 3 },
        default: true,
      },
      [FIELD_TYPES.MULTISELECT]: {
        title: LABELS.FIELD_TYPE_MULTISELECT,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 3 },
        default: true,
      },
      [FIELD_TYPES.SUB_FORM]: {
        title: LABELS.FIELD_TYPE_SUBFORM,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 3 },
        default: true,
      },
      [FIELD_TYPES.W_PAINT]: {
        title: LABELS.FIELD_TYPE_WPAINT,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 3 },
        default: true,
      },
      [FIELD_TYPES.GPS]: {
        title: LABELS.FIELD_TYPE_GPS,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 3 },
        default: true,
      },
      [FIELD_TYPES.SIGNATURE]: {
        title: LABELS.FIELD_TYPE_SIGNATURE,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 3 },
        default: true,
      },
      [FIELD_TYPES.CAMERAS]: {
        title: LABELS.FIELD_TYPE_CAMERAS,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 3 },
        default: true,
      },
      [FIELD_TYPES.SLIDER]: {
        title: LABELS.FIELD_TYPE_SLIDER,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 3 },
        default: true,
      },
      [FIELD_TYPES.MAP]: {
        title: LABELS.FIELD_TYPE_MAP,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 3 },
        default: true,
      },
      [FIELD_TYPES.LINK]: {
        title: LABELS.FIELD_TYPE_LINK,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 3 },
        default: true,
      },
      [FIELD_TYPES.RATING]: {
        title: LABELS.FIELD_TYPE_RATING,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 3 },
        default: true,
      },
      [FIELD_TYPES.CAPTCHA]: {
        title: LABELS.FIELD_TYPE_CAPTCHA,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 3 },
        default: true,
      },
      /* Form designerben fixen ki van most szedve (form-designer/components/palette/palette.ts)
      [FIELD_TYPES.STATUS]: {
        title: LABELS.FIELD_TYPE_STATUS,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 3 },
        default: true,
      },*/
    },
  },
  fieldOptions: {
    type: 'object',
    title: LABELS.FD_FIELD_AVAILABLE_FEATURES,
    format: 'grid-strict',
    options: {
      collapsed: true,
    },
    properties: {
      resizable: {
        // @TODO meretezhetoek-e a mezok || gridItem isResizable propja Doma
        title: LABELS.FD_FIELD_IS_RESIZABLE,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 12 },
        default: true,
      },
      fixWidth: {
        // @TODO egy sor egy mezo, teljes szelessegben Doma
        title: LABELS.FD_FIELD_FIX_WIDTH,
        type: 'string',
        enum: ['original', '4', '6', '8', '10', '12'],
        default: 'original',
        options: { grid_columns: 12 },
      },
      edit: {
        // @TODO mezok adatainak szerkesztes lehetosege (a regin nem mukodott, klikkre megnyilt a popup)
        title: LABELS.FD_FIELD_EDITABLE,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 6 },
        default: true,
      },
      delete: {
        // @TODO torles lehetosege a mezokon Doma
        title: LABELS.FD_FIELD_REMOVABLE,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 6 },
        default: true,
      },
      moveField: {
        // @TODO mezok mozgatasanak lehetosege csoportok kozott Doma
        title: LABELS.FD_FIELD_TRANSFERABLE_BETWEEN_GROUPS,
        type: 'boolean',
        format: 'checkbox',
        options: { grid_columns: 12 },
        default: true,
      },
      fieldProperties: {
        title: LABELS.FD_FIELD_PROPERTIES,
        type: 'object',
        format: 'grid-strict',
        options: {
          collapsed: true,
          grid_columns: 12,
        },
        properties: {
          show: {
            title: LABELS.FD_ENABLE_FIELD_PROPERTIES,
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 12 },
            default: true,
          },
          [COMMON_PROPERTY_NAMES.NAME]: {
            title: LABELS[COMMON_PROPERTY_SCHEMA_NAMES.NAME],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [COMMON_PROPERTY_NAMES.DESCRIPTION]: {
            title: LABELS[COMMON_PROPERTY_SCHEMA_NAMES.DESCRIPTION],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
        },
      },
      fieldLanguage: {
        type: 'object',
        title: LABELS.FIELD_LANGUAGE,
        format: 'grid-strict',
        options: {
          collapsed: true,
          grid_columns: 12,
        },
        properties: {
          show: {
            title: LABELS.FD_ENABLE_FIELD_LANGUAGE,
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 12 },
            default: true,
          },
          [COMMON_PROPERTY_NAMES.LOCALIZATION_KEY]: {
            title: LABELS[COMMON_PROPERTY_SCHEMA_NAMES.LOCALIZATION_KEY],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [COMMON_PROPERTY_NAMES.DISPLAY_NAME]: {
            title: LABELS[COMMON_PROPERTY_SCHEMA_NAMES.DISPLAY_NAME],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
        },
      },
      fieldData: {
        type: 'object',
        title: LABELS.FIELD_DATA,
        format: 'grid-strict',
        options: {
          collapsed: true,
          grid_columns: 12,
        },
        properties: {
          show: {
            title: LABELS.FD_ENABLE_FIELD_DATA,
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 12 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.SAVE_DATA]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.SAVE_DATA],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.OPTIONS_JSON]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.OPTIONS_JSON],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.HTML_VALUE]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.HTML_VALUE],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.MAP_DATA_ENTITY]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.MAP_DATA_ENTITY],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.MAP_PROPERTIES]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.MAP_PROPERTIES],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.MAP_DEFAULT_ADDRESS_EXP]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.MAP_DEFAULT_ADDRESS_EXP],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.VALUE_FROM_PARAM]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.VALUE_FROM_PARAM],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.LIST_SOURCE]: {
            title: LABELS[FIELD_PROPERTY_NAMES.LIST_SOURCE],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
        },
      },
      fieldValidation: {
        type: 'object',
        title: LABELS.FIELD_VALIDATION,
        format: 'grid-strict',
        options: {
          collapsed: true,
          grid_columns: 12,
        },
        properties: {
          show: {
            title: LABELS.FD_ENABLE_FIELD_VALIDATION,
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 12 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.UNIQUE]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.UNIQUE],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.MIN_LENGTH]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.MIN_LENGTH],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.MAX_LENGTH]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.MAX_LENGTH],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.PATTERN]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.PATTERN],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.DECIMAL]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.DECIMAL],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.MAX_FILE_SIZE]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.MAX_FILE_SIZE],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.FILE_TYPES]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.FILE_TYPES],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.MIN_EXP]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.MIN],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.MAX_EXP]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.MAX],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.SUB_MIN_NUMBER_OF_REC]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.SUB_MIN_NUMBER_OF_REC],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.SUB_MAX_NUMBER_OF_REC]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.SUB_MAX_NUMBER_OF_REC],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
        },
      },
      fieldAppearance: {
        type: 'object',
        title: LABELS.FIELD_APPEARANCE,
        format: 'grid-strict',
        options: {
          collapsed: true,
          grid_columns: 12,
        },
        properties: {
          show: {
            title: LABELS.FD_ENABLE_FIELD_APPEARANCE,
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 12 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.PLACEHOLDER]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.PLACEHOLDER],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.DATE_PICKER_VIEW]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.DATE_PICKER_VIEW],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.CALENDAR_OPTIONS]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.CALENDAR_OPTIONS],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.TEMPLATE_ITEM]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.TEMPLATE_ITEM],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.FORMATTED_TEXT]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.FORMATTED_TEXT],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.THOUSAND_SEPARATED]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.THOUSAND_SEPARATED],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.UNDERLINE]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.UNDERLINE],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.PREFIX_ICON]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.PREFIX_ICON],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.ROWS]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.ROWS],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
        },
      },
      fieldBehaviour: {
        type: 'object',
        title: LABELS.FIELD_BEHAVIOUR,
        format: 'grid-strict',
        options: {
          collapsed: true,
          grid_columns: 12,
        },
        properties: {
          show: {
            title: LABELS.FD_ENABLE_FIELD_BEHAVIOUR,
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 12 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.NO_CLONING]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.NO_CLONING],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.CREATE_NEW_ELEMENT]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.CREATE_NEW_ELEMENT],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.DROPDOWN_ONLY_ONE]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.DROPDOWN_ONLY_ONE],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.DIRECT_INPUT_ENTRY]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.DIRECT_INPUT_ENTRY],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.TAGGABLE]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.TAGGABLE],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.MULTISELECT]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.MULTISELECT],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.TIME_SELECT_FORM]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.TIME_SELECT_FORM],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.TIME_FORMAT]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.TIME_FORMAT],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.SUB_REC_EXTENDABLE]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.SUB_REC_EXTENDABLE],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.SUB_REC_DELETABLE]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.SUB_REC_DELETABLE],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
        },
      },
      fieldTechnical: {
        type: 'object',
        title: LABELS.FIELD_TECHNICAL,
        format: 'grid-strict',
        options: {
          collapsed: true,
          grid_columns: 12,
        },
        properties: {
          show: {
            title: LABELS.FD_ENABLE_FIELD_TECHNICAL,
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 12 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.IS_TECHNICAL]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.IS_TECHNICAL],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.IS_STATIC]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.IS_STATIC],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.FORM_DATA_PROCESS_ID]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.FORM_DATA_PROCESS_ID],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.CAPTCHA_TYPE]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.CAPTCHA_TYPE],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.LINK_TYPE]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.LINK_TYPE],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.SUB_FORM_PROPS]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.SUB_FORM_PROPS],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.SUBFORM_PURE]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.SUBFORM_PURE],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
        },
      },
      activeProperties: {
        type: 'object',
        title: LABELS.FD_FIELD_ACTIVE_PROPERTIES,
        format: 'grid-strict',
        options: {
          collapsed: true,
          grid_columns: 12,
        },
        properties: {
          show: {
            title: LABELS.FD_ENABLE_FIELD_ACTIVE_PROPERTIES,
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 12 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.LABEL_EXP]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.LABEL_EXP],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.HIDDEN_EXP]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.HIDDEN_EXP],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.READ_ONLY_EXP]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.READ_ONLY_EXP],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.REQUIRED_EXP]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.REQUIRED_EXP],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.VALUE_EXP]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.VALUE_EXP],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.FILTER_EXP]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.FILTER_EXP],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
          [FIELD_PROPERTY_NAMES.PROPERTY_OVERRIDE]: {
            title: LABELS[FIELD_PROPERTY_SCHEMA_NAMES.PROPERTY_OVERRIDE],
            type: 'boolean',
            format: 'checkbox',
            options: { grid_columns: 4 },
            default: true,
          },
        },
      },
    },
  },
}
